import { cn, Typography } from '@altify/components';
import appHelpers from '@utils/app-urls';
import { InfoModalCallable } from 'components/InfoModal/InfoModal';
import useBreakpoint from 'hooks/useBreakpoint';
import { TouchableOpacity } from 'react-native';
import { Placement } from 'tippy.js';
import { InfoTooltip } from '../InfoTooltip/InfoTooltip';

const cdnURL = appHelpers.getCDNUrl();
const infoIcon = `${cdnURL}assets/products/general/info.svg`;

type ContentProps =
  | {
      text: string;
      children?: never;
    }
  | {
      children: React.ReactNode;
      text?: never;
    };

export function InfoButton({
  title,
  text,
  children,
  useDesktopModal = false,
  tooltipPlacement,
  className,
  showTitle = false,
}: {
  title: string;
  useDesktopModal?: boolean;
  tooltipPlacement?: Placement;
  className?: string;
  showTitle?: boolean;
} & ContentProps) {
  const { isSmaller } = useBreakpoint();
  const isMobile = isSmaller('sm');

  const useModal = isMobile || useDesktopModal;

  const content = text ? <Typography>{text}</Typography> : <>{children}</>;

  function handleClick() {
    if (useModal) {
      if (text) {
        InfoModalCallable.call({
          title,
          text,
        });
      } else {
        InfoModalCallable.call({
          title,
          children,
        });
      }
    }
  }

  return useModal ? (
    <TouchableOpacity
      onPress={handleClick}
      className={cn('flex flex-row items-center gap-2', className)}>
      {showTitle && <Typography className="text-body-text">{title}</Typography>}
      <img src={infoIcon} alt="info" width="15px" height="15px" />
    </TouchableOpacity>
  ) : (
    <div className={cn('flex flex-row items-center gap-2', className)}>
      {showTitle && <Typography className="text-body-text">{title}</Typography>}
      <InfoTooltip placement={tooltipPlacement}>{content}</InfoTooltip>
    </div>
  );
}
